// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33U-u","label":"styles_label__1_60A"};